module.exports = __webpack_public_path__ + "static/img/icon12.97a376ca.png";